$(function(){

	// windowの横縦を取得
	var w = $(window).width();

////////////////////////////////////
///スライダー
////////////////////////////////////

	$('.item-single__slider').slick({
		dots: true,				//ページャーの有無
		arrows: true,			//矢印の有無
		prevArrow:'<div class="slick-arrow-prev"></div>',
		nextArrow:'<div class="slick-arrow-next"></div>',
		slidesToShow: 1,
		autoplay: false,		//自動：true / 手動：false
		speed: 2000,			//スピード
		autoplaySpeed: 3000,	//スライドの速度
		pauseOnHover: false		//オンマウスで一時停止させるかどうか
	});

////////////////////////////////////
///セレクトメニューがあった場合、--を削除
////////////////////////////////////

	window.onload = function () {
		$('.makeshop-option-select').find('.makeshop-option-select-title').html('選択してください');
	}

////////////////////////////////////
///セレクトメニューがあった場合、arrow要素を付与
////////////////////////////////////

	if($('.makeshop-option-wrap').length){
		$('.makeshop-option-wrap').append('<span class="arrow"></span>');
	}

});